
import postcssStyledJsxUrlLoader_0 from '../../../../library/images/paper-strip.png';
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.webinars__hero-wrap {
  position: relative;
  overflow: hidden;
  grid-column: left-gutter / span 3;
  max-width: $container-max-width;
  margin: 0 auto;
  width: 100%;
}

.webinars__hero {
  width: 100%;
  display: grid;
  padding: 60px 40px;
  background-position: top right;
  background-size: cover;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 30px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    background-image: url("${postcssStyledJsxUrlLoader_0}");
    background-size: 1440px 30px;
    background-position: bottom left;
  }
}

.webinars__hero-heading {
  position: relative;
  z-index: 2;
}

.webinars__hero--white .webinars__hero-heading {
  color: white;
}

.webinars__hero-inner {
  display: grid;
  grid-template-columns: [left] 3fr [right] 2fr;
  grid-column-gap: 40px;
  grid-row-gap: 40px;
  align-items: center;
}

.webinars__hero-texture {
  position: absolute;
  top: 35px;
  right: -40px;
  bottom: 0;
  width: 80%;
  min-height: calc(100% + 35px);
  z-index: 0;
}

.webinars__hero-heading {
  grid-column: left / span 2;
  font-weight: 600;
  text-align: center;

  span {
    line-height: 1 !important;
  }

  h2 {
    margin-top: 30px;
    font-weight: 400;
  }
}

.webinars__hero-form-wrap {
  grid-column: left / span 2;
  position: relative;
}

.webinars__form {
  background: white;
  text-align: center;
  border-radius: 6px;
  position: relative;
  z-index: 2;

  padding: 30px;

  @include media-query(tablet) {
    padding: 40px;
  }

  @include media-query(desktop) {
    padding: 50px;
  }

  &--confirmation {
    padding: 20px;

    h3 {
      font-size: 36px;
    }

    > * + * {
      margin-block-start: 1em;
    }

    .webinar-start {
      color: $blue-legacy;
    }

    .calendar-links {
      display: flex;
      justify-content: center;

      > * {
        flex: 1 0 0;
      }

      > * + * {
        margin-inline-start: 1em;
      }
    }
  }

  &-error {
    background-color: $ui-error-legacy;
    border-radius: 3px;
    padding: 8px 40px;
    font-size: 14px;
    margin-top: 5px;
    text-align: left;

    &:first-of-type {
      margin-top: 20px;
    }
  }
}

.webinars__hero-video-wrap {
  position: absolute;
  width: 800px;
  max-width: 100%;
  top: 50%;
  left: 50%;
  padding: 0 20px;
  transform: translate3d(-50%, -50%, 0);
  line-height: 0;
  z-index: 2;
}

.webinars__hero-video {
  width: 100%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  height: 0;
  padding-bottom: 56.25%;
  background-size: cover;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 3px;
}

.webinars__hero-video--visible {
  opacity: 1;
}

.webinars__hero-playing {
  .webinars__hero-heading {
    opacity: 0.5;
    filter: blur(4px);
    transition: filter 0.3s, -webkit-filter 0.3s, opacity 0.3s;
  }

  .webinars__form {
    opacity: 0;
    transition: opacity 0.3s;
  }
}

@media (min-width: 768px) {
  .webinars__hero-wrap {
    padding-top: 20px;
  }

  .webinars__hero-heading {
    grid-column: left;
    text-align: left;
  }

  .webinars__hero-form-wrap {
    grid-column: right;
    max-width: 380px;
    position: static;
  }

  .webinars__hero-texture {
    left: auto;
    right: 0;
    top: 0;
    width: 35%;
    min-height: 100%;
  }

  .webinars__hero-heading h1 span {
    font-size: 50px;
  }
}

@media (min-width: 990px) {
  .webinars__hero-heading h1 span {
    font-size: 60px;
  }
}

@media (min-width: 1200px) {
  .webinars__hero {
    padding-left: 100px;
    padding-right: 100px;
    grid-column: content;
  }

  .webinars__hero-texture {
    width: 425px;
  }
}
`